<template>
  <!-- <v-alert v-bind="$attrs" v-on="$listeners">
      <slot name="default"></slot>
    </v-alert> -->
  <v-alert v-bind="$attrs" v-on="$listeners">
    <v-row align="center">
      <v-col class="grow py-0">
        <slot name="default"></slot>
      </v-col>
      <v-col class="shrink py-0">
        <slot name="action"></slot>
      </v-col>
    </v-row>
    <!-- <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template> -->
  </v-alert>
</template>

<script>
export default {
  props: {
    //
  },

  data: () => ({
    //
  }),

  methods: {
    hasSlot(name = 'default') {
      return !!this.$slots[name] || !!this.$scopedSlots[name]
    },
    //
  },
}
</script>
